<template>
  <transition name="om-fade">
    <div
      v-show="visible"
      class="om-modal"
      :class="className"
      :style="style"
      @touchmove.prevent.stop
      @click="$emit('click', $event)"
    />
  </transition>
</template>

<script>
export default {
  name: 'modal',

  props: {
    visible: Boolean,
    zIndex: Number,
    className: String,
    customStyle: Object
  },

  computed: {
    style() {
      return {
        zIndex: this.zIndex,
        ...this.customStyle
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/mixins/popup/Modal.vue